var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',{attrs:{"fluid":""}},[_c('DataTableAG',{attrs:{"columns":_vm.columns,"width":"1600px","height":"750px","getcontentpath":_vm.getcontentpath,"jsonobject":"benefitcodes","rowHeight":120}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }